import amount from './amount.filter';
import number from './number.filter';
import quantity from './quantity.filter';
import coefficient from './coefficient.filter';
import amountcustom from './amountcustom.filter';


export default {
  amount,
  number,
  quantity,
  coefficient,
  amountcustom
};
